<template>
  <div>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <br/>
    <div v-if="sendMail===false">
      <div class="w3-center">
        <img src="../../../../static/img/G3-School.gif" style="width:100%;"><br><br>
        <div align="center"><FONT  size="6" color="#008080"><B>Pre Registration Form</B></FONT> </div><br>
      </div>
      <form>
        <div class="row">
          <div style="width: 50%; margin-top: 10px;">
            <div style="text-align:right;"><strong><label>Student’s Name*</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
            <div style="text-align:right; margin-top: 16px;"><strong><label>Father’s Name*</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
            <div style="text-align:right; margin-top: 18px;"><strong><label>Phone No*</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
            <div style="text-align:right; margin-top: 15px;"><strong><label>Class*</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
            <div style="text-align:right; margin-top: 20px;"><strong><label>Address</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
          </div>
          <div style="width: 50%;">
            <div style="text-align:left; margin-bottom: 10px;"><input class="inp" name="stu-name" id="stu-name" placeholder="Enter Student Name" required></div>
            <div style="text-align:left; margin-bottom: 10px;"><input class="inp" name="fath-name" id="fath-name" placeholder="Enter Father Name" required></div>
            <div style="text-align:left; margin-bottom: 10px;"><input class="inp" id="mobile" maxlength="10" v-on:keypress="isNumber(event)" placeholder="Enter mobile number" autofocus></div>
            <div style="text-align:left; margin-bottom: 10px;">
              <select class="inp" id="classs">
                <option value="Pre Nursery (2+ Yrs)">Pre Nursery (2+ Yrs)</option>
                <option value="Nursery (3+ Yrs)">Nursery (3+ Yrs)</option>
                <option value="KG (4+ Yrs)">KG (4+ Yrs)</option>
                <option value="1st Class (5+ Yrs)">1st Class (5+ Yrs)</option>
                <option value="2nd Class">2nd Class</option>
                <option value="3rd Class">3rd Class</option>
                <option value="4th Class">4th Class</option>
                <option value="5th Class">5th Class</option>
                <option value="6th Class">6th Class</option>
                <option value="7th Class">7th Class</option>
                <option value="8th Class">8th Class</option>
                <option value="9th Class">9th Class</option>
                <option value="11th (Medical)">11th (Medical)</option>
                <option value="11th (Non Medical)">11th (Non Medical)</option>
                <option value="11th (Commerce)">11th (Commerce)</option>
                <option value="11th (Humanities)">11th (Humanities)</option>
              </select>
            </div>
            <div style="text-align:left; margin-bottom: 5px;"><input class="inp" name="address" id="address" placeholder="Enter Address"></div>
          </div>
        </div>
        <br>
        <b-notification type="is-danger" :closable="false" :active.sync="isActive">
            {{this.errors}}
        </b-notification>
        <div class="w3-center">
          <input class="email" value="Submit" type="button" v-on:click="email();">
        </div>
      </form>
    </div>
    <div v-if="sendMail">
      <div class="w3-center">
        <img src="../../../../static/img/G3-School.gif" style="width:100%;"><br><br>
        <div align="center"><FONT  size="4" color="#008080"><B>Thanks for registering your child. School admission coordinator will get back to you soon.</B></FONT> </div><br>
        * Admissions are subject of clearing entrance test of school and availability of seats. <br>Filling the pre registration form is not confirming the admission of child.
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    data () {
      return {
        isActive: false,
        sendMail: false,
        isLoading: false,
        errors: ''
      }
    },
    created () {
    },
    methods: {
      email () {
        this.isLoading = true
        var studentName = document.getElementById('stu-name').value
        var fatherName = document.getElementById('fath-name').value
        var mobile = document.getElementById('mobile').value
        var classs = document.getElementById('classs').value
        var address = document.getElementById('address').value
        if (address === '') {
          address = 'not set'
        }
        if (studentName === '') {
          this.errors = 'Student’s Name not set'
          this.isActive = true
        } else if (fatherName === '') {
          this.errors = 'Father’s Name not set'
          this.isActive = true
        } else if (isNaN(mobile) || mobile.length !== 10 || mobile === '') {
          this.errors = 'Oops! Invalid Mobile No.'
          this.isActive = true
        } else {
          const params = new URLSearchParams()
          params.append('student_name', studentName)
          params.append('father_name', fatherName)
          params.append('mobile', mobile)
          params.append('class', classs)
          params.append('address', address)
          axios({
            url: process.env.BASE_API + '/users/send-mail-for-gschool',
            method: 'post',
            data: params,
            withCredentials: false,
            headers: {
            }
          })
          .then(response => {
            if (response.data.status === '000000') {
              this.isActive = false
              this.sendMail = true
              this.isLoading = false
            } else {
              this.errors = 'Oops! Something went wrong'
              this.isActive = true
              this.isLoading = false
            }
            // console.log(response)
            if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
              this.list = response.data.user_record
              alert(this.list)
            }
          })
          .catch(e => {
            alert('not ok')
          })
        }
      },
      onAmmountChange () {
        this.errors = ''
        this.isActive = false
        document.getElementById('mobile').value = Number(document.getElementById('mobile').value)
      },
      isNumber: function (evt) {
        if (!evt) {
          evt = window.event
        }
        // evt = (evt) ? evt : window.event
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault()
        } else {
          return true
        }
      }
    }
  }
</script>
<style>
.inp {width: 170px; height: 40px;}
.email {background-color: #008080; padding: 1% 8% 1% 8%; margin-bottom: 40%; color: white; border: none; border-radius: 5% 5% 5% 5%;}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/G3school.vue